module.exports = __webpack_public_path__ + "img/laoding.14c42fe8.gif";